class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    // Add the toggle event only if the element doesn't have 'data-mega-menu' attribute
    if (!this.mainDetailsToggle.hasAttribute('data-mega-menu')) {
      this.mainDetailsToggle.addEventListener('toggle', () => this.onToggle());
    }

    this.mainDetailsToggle.addEventListener('focusout', () => this.onFocusOut());
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');

    // Check if the element has the 'data-mega-menu' attribute
    if (this.mainDetailsToggle.hasAttribute('data-mega-menu')) {
      // Prevent default click behavior on summary for mega menu
      this.mainDetailsToggle.querySelector('summary').addEventListener('click', (event) => event.preventDefault());

      // Add hover event listeners for mega menu behavior
      this.mainDetailsToggle.addEventListener('mouseover', () => this.onHover());
      this.addEventListener('mouseleave', () => this.onMouseLeave()); // Change to listen to mouseleave on HeaderMenu
    }
  }

  onHover() {
    this.mainDetailsToggle.setAttribute('open', true);
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);

    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  onMouseLeave() {
    this.close(); // Close when mouse leaves HeaderMenu
  }
}

customElements.define('header-menu', HeaderMenu);
